<template>
    <b-row>
        <b-col cols="12" class="col-content-recurso-prev mb-3 mt-3">
            <img class="img-recurso-prev" v-if="data.type == 'IMAGEN'" :src="$root.setUrlFile(data.file)" alt="">
            <b-col v-else-if="data.type == 'AUDIO'" class="audio-element mb-3">
                <font-awesome-icon icon="volume-down" class="animated infinite heartBeat" />
                <audio :src="$root.setUrlFile(data.file)" controls="controls" autobuffer="autobuffer"></audio>
            </b-col>
            <video v-else controls>
                <source :src="$root.setUrlFile(data.file)">  
            </video>
        </b-col>
    </b-row>
</template>
<style lang="scss">
.col-content-recurso-prev{
    text-align: center;
}
.img-recurso-prev{
    display: block;
    margin: auto;
}
</style>
<script>
export default {
    name:'pre-imagen',
    props: {
        data: {
            type: Object,
            default: () => {
                return {
                    index: null,
                    tag: 'Recurso',
                    type: null,
                    file: null,
                    link: null
                }
            }
        }
    }
}
</script>